export const FAKE_LOCAL_TESTING_PASSWORD = '123';
export const MAX_NUM_SEATS = 11;
export const MAX_CARD_PIXEL_HEIGHT = 160;
/**
 * No need to show card backs (in a default showdown) as large as when they are revealed.
 */
export const MAX_CARD_BACK_PIXEL_HEIGHT = 80;
export const ROW_MODE_PANEL_WIDTH_PERCENT = 30;
export const COLUMN_MODE_PANEL_HEIGHT_PERCENT = 30;
export const POKER_SEAT_ROUNDED_RECT_RADIUS = 30;
export const SUPER_ADMIN_IDS = [
    1, // ZenBlender
    11198 // viday
];
export const DEFAULT_FONT_FAMILY = 'DefaultTriplejackFont';
export const BOLD_FONT_FAMILY = 'BoldTriplejackFont';
export const SECONDARY_FONT_FAMILY = 'SecondaryTriplejackFont';
export const ALL_FONT_FAMILIES = [DEFAULT_FONT_FAMILY, BOLD_FONT_FAMILY, SECONDARY_FONT_FAMILY];
export const NON_BREAKING_SPACE = ' ';
export const MIN_STAGE_WIDTH_PX = 180;
export const MIN_STAGE_HEIGHT_PX = 150;
export const ENTRY_SCENE_ALERT = '';
export const MAX_RESOLUTION = 2;
export const BLUESKY_ACCOUNT_URL = 'https://bsky.app/profile/triplejack.com';
export const TWITTER_ACCOUNT_URL = 'https://twitter.com/Triplejack';
export const PRE_FLOP_BET_ROUND_NUMBER = 1;
export const FLOP_BET_ROUND_NUMBER = 2;
export const TURN_BET_ROUND_NUMBER = 3;
export const RIVER_BET_ROUND_NUMBER = 4;
export const DUAL_LIMIT_AUTO_ENABLED_BUY_IN_THRESHOLD = 2500;
export const FREE_CHIPS_REBUY_AMOUNT = 2500;
